var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoardmember(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "boardmember_svg__nc-icon-wrapper",
    stroke: "#111",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 1.5,
    "data-cap": "butt"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 11.5h1a3 3 0 013 3v0h0-7 0v0a3 3 0 013-3z",
    "data-cap": "butt"
  }), /*#__PURE__*/React.createElement("path", {
    "data-cap": "butt",
    "data-color": "color-2",
    d: "M.5 6.5l7.5-5 7.5 5"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNiAxNiI+PGcgY2xhc3M9Im5jLWljb24td3JhcHBlciIgc3Ryb2tlPSIjMTExMTExIj48Y2lyY2xlIGN4PSI4IiBjeT0iOCIgcj0iMS41IiBmaWxsPSJub25lIiBzdHJva2U9IiMxMTExMTEiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgZGF0YS1jYXA9ImJ1dHQiLz4gPHBhdGggZD0iTTcuNSwxMS41aDFhMywzLDAsMCwxLDMsM3YwYTAsMCwwLDAsMSwwLDBoLTdhMCwwLDAsMCwxLDAsMHYwQTMsMywwLDAsMSw3LjUsMTEuNVoiIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzExMTExMSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBkYXRhLWNhcD0iYnV0dCIvPiA8cG9seWxpbmUgcG9pbnRzPSIwLjUgNi41IDggMS41IDE1LjUgNi41IiBmaWxsPSJub25lIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIGRhdGEtY2FwPSJidXR0IiBkYXRhLWNvbG9yPSJjb2xvci0yIi8+PC9nPjwvc3ZnPg==";
export { SvgBoardmember as ReactComponent };